<template>
    <label>
        <span :class="{'focused': focused || value != ''}" class="title">{{title}}</span>
        <input
            :type="inputType"
            @change="inputHandler"
            :value="value"
            @focus="focused = true"
            @blur="focused = false"
            :name="name"
            :required="isRequired"
            :autocomplete="inputType == 'password' ? 'new-password' : 'off'"
            ref="input"
        />
        <i class="material-icons error" v-show="isError">error</i>
        <i
            class="material-icons clear"
            v-show="!isError && value.length > 0"
            @click="$emit('clear')"
        >cancel</i>
        <span class="helper" v-show="!isError">{{helperText}}</span>
        <span class="error-message" v-show="isError">{{errorMessage}}</span>
    </label>
</template>

<script>
export default {
    props: {
        inputType: {
            type: String,
            default: 'text',
        },
        value: {
            type: [String, Number],
        },
        title: String,
        isError: {
            type: Boolean,
            default: false,
        },
        helperText: String,
        errorMessage: String,
        name: String,
        isRequired: {
            type: Boolean,
            default: false,
        },
        focus: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        if(this.focus) {
            this.$refs.input.focus()
        }
    },
    methods: {
        inputHandler(e) {
            this.$emit('input', e.target.value)
        },
    },
    data() {
        return {
            focused: false,
        }
    },
}
</script>

<style scoped lang="scss">
$border-color: $green-main;
label {
    width: 197 * $rem;
    position: relative;
    display: inline-block;
    height: 40 * $rem;

    span.title {
        color: rgb(70, 70, 70);
        position: absolute;
        top: 10 * $rem;
        font-size: 15 * $rem;
        margin-left: 15 * $rem;
        transition: all 0.2s ease-out;
        background-color: white;
        white-space: nowrap;
        cursor: text;
        max-width: 190 * $rem;
        overflow: hidden;
        text-overflow: ellipsis;

        &.focused {
            top: -6 * $rem;
            font-size: 12 * $rem;
            color: $border-color;
            padding-left: 2 * $rem;
            padding-right: 2 * $rem;
            left: 0;
        }
    }

    input {
        width: 100%;
        height: 40 * $rem;
        border-radius: 5 * $rem;
        box-shadow: none;
        border: 1 * $rem solid #b4b4b4;
        color: #474747;
        font-size: 15 * $rem;
        padding-left: 15 * $rem;
        outline: none;

        &:focus {
            border: 1 * $rem solid $border-color;
        }
    }

    .material-icons {
        font-size: 18 * $rem;
        position: absolute;
        right: 15 * $rem;
        top: 10 * $rem;

        &.error {
            color: rgb(175, 3, 3);
        }

        &.clear {
            cursor: pointer;
            color: #b4b4b4;
        }
    }

    .helper {
        position: absolute;
        top: 45 * $rem;
        left: 30 * $rem;
        font-size: 12 * $rem;
        color: #5c5c5c;
        width: calc(100% - 30 *#{$rem});
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        overflow: hidden;
    }

    .error-message {
        position: absolute;
        top: 43 * $rem;
        left: 15 * $rem;
        font-size: 12 * $rem;
        color: rgb(175, 3, 3);
        width: calc(100% - 15 *#{$rem});
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        overflow: hidden;
    }
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
